import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class ConditionalLink extends Component {
  render() {
    const { condition, url, id, onClick, className, children, ...additionalAttributes } = this.props;

    if (condition && localStorage.license === "base") {
      return (
        <Link to={url} id={id} onClick={onClick} className={className} {...additionalAttributes}>
          {children}
        </Link>
      )
    }
    else {
      return (
        <span id={id} className={className + " not-clickable"} {...additionalAttributes}>
          {this.props.children}
        </span>
      );
    }
  }
}

export default ConditionalLink;
